module.exports = __webpack_public_path__ + "static/media/zips2.6538b7bc.png";